import * as React from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { DeveloperRoutes } from "src/common/developers";

type AllProps = {
  active_path?: string;
}

function UiGuideNavigationComponent(props: AllProps) {
  const { active_path } = props;

  return (
    <Nav>
      <Link title="Breadcrumbs"
        className={`nav-link${active_path === DeveloperRoutes.breadcrumbs_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.breadcrumbs_route}`} 
      >
        <span>Breadcrumbs</span>
      </Link>
      <Link title="Buttons"
        className={`nav-link${active_path === DeveloperRoutes.buttons_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.buttons_route}`} 
      >
        <span>Buttons</span>
      </Link>
      <Link title="Cards"
        className={`nav-link${active_path === DeveloperRoutes.cards_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.cards_route}`} 
      >
        <span>Cards</span>
      </Link>
      <Link title="Date Picker"
        className={`nav-link${active_path === DeveloperRoutes.date_picker_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.date_picker_route}`} 
      >
        <span>Date Picker</span>
      </Link>
      <Link title="Drag and Drop"
        className={`nav-link${active_path === DeveloperRoutes.drag_and_drop_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.drag_and_drop_route}`} 
      >
        <span>Drag and Drop</span>
      </Link>
      <Link title="Forms"
        className={`nav-link${active_path === DeveloperRoutes.forms_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.forms_route}`} 
      >
        <span>Forms</span>
      </Link>
      <Link title="Icons"
        className={`nav-link${active_path === DeveloperRoutes.icons_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.icons_route}`} 
      >
        <span>Icons</span>
      </Link>
      <Link title="Messaging"
        className={`nav-link${active_path === DeveloperRoutes.messaging_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.messaging_route}`} 
      >
        <span>Messaging</span>
      </Link>
      <Link title="Modals"
        className={`nav-link${active_path === DeveloperRoutes.modals_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.modals_route}`} 
      >
        <span>Modals</span>
      </Link>
      <Link title="Pagination"
        className={`nav-link${active_path === DeveloperRoutes.pagination_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.pagination_route}`} 
      >
        <span>Pagination</span>
      </Link>
      <Link title="Popovers"
        className={`nav-link${active_path === DeveloperRoutes.popovers_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.popovers_route}`} 
      >
        <span>Popovers</span>
      </Link>
      <Link title="Progress Bar"
        className={`nav-link${active_path === DeveloperRoutes.progress_bar_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.progress_bar_route}`} 
      >
        <span>Progress Bar</span>
      </Link>
      <Link title="Public Cards"
        className={`nav-link${active_path === DeveloperRoutes.public_cards_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.public_cards_route}`} 
      >
        <span>Public Cards</span>
      </Link>
      <Link title="Scrollbar"
        className={`nav-link${active_path === DeveloperRoutes.scrollbar_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.scrollbar_route}`} 
      >
        <span>Scrollbar</span>
      </Link>
      <Link title="Tabs"
        className={`nav-link${active_path === DeveloperRoutes.tabs_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.tabs_route}`} 
      >
        <span>Tabs</span>
      </Link>
      <Link title="Toastrs"
        className={`nav-link${active_path === DeveloperRoutes.toastr_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.toastr_route}`} 
      >
        <span>Toastrs</span>
      </Link>
      <Link title="Typography"
        className={`nav-link${active_path === DeveloperRoutes.typography_route ? " active" : ""}`}
        to={`/${DeveloperRoutes.developer_route}/${DeveloperRoutes.ui_guide_route}/${DeveloperRoutes.typography_route}`} 
      >
        <span>Typography</span>
      </Link>
    </Nav>
  );
}

export default React.memo(UiGuideNavigationComponent);
